import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Aside from "../../../components/Aside";
import CustomDataTable from "../../../components/CustomDataTable";
import Footer from "../../../components/Footer";
import Header from "../../../components/Header";
import Button from "../../../components/form-controls/Button";
import { ShortLinksService } from "../../../services/ShortLinksService";
import { DateUtil } from "../../../utils/date";
import { QRCodeSVG } from 'qrcode.react';
import { AlertService } from "../../../services/Alert";
import CreateLinkModal from "./CreateLinkModal";
import EmbedCodeModal from "./EmbedCodeModal";
import EditLinkModal from "./EditLinkModal";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import { APPS, PROFILES } from "../../../constants";
import { useTranslation } from "react-i18next";
import { useSession } from "../../../hooks/useSession";
import useRequest from "../../../hooks/useRequest";
import PieChart from "../../../components/PieChart";
const MessageLinksPage = () => {

    const { t } = useTranslation();

    const { account } = useCurrentAccount();

    const { call, isRequesting } = useRequest();

    const { state: { channel } } = useLocation()

    const navigate = useNavigate();

    const [links, setLinks] = useState([])
    const [showModalAdd, setShowModalAdd] = useState(false)
    const [showModalEmbed, setshowModalEmbed] = useState({
        show: false,
        link: null
    })
    const [showModalEdit, setShowModalEdit] = useState({
        show: false,
        link: null
    })

    const columns = useMemo(() => [
        {
            name: t("platform.channels.links-page.link"),
            sortable: true,
            with: 25,
            selector: row => row.link,
            cell: (row) => (
                <div className="d-flex align-items-center flex-column gap-2">
                    <QRCodeSVG id={`qr-img-${row.token}`} value={`https://${row.link}`} size={50} />
                    <div className="link-underline ms-3">{row.link}</div>
                </div>
            )
        },
        {
            name: t("platform.channels.links-page.message"),
            sortable: true,
            selector: row => row.message,
        },
        {
            name: t("platform.channels.links-page.ttl-col"),
            sortable: true,
            center: true,
            width: 10,
            selector: row => row.expire_at,
            cell: (row) => {
                if (!row.expire_at) {
                    return <span className="text-muted">-</span>;
                }
                
                const dateOnly = row.expire_at.split('T')[0];
                const expireDate = new Date(dateOnly + 'T12:00:00');
                const today = new Date();
                const isExpired = expireDate < today;
                
                if (isExpired) {
                    return <span className="badge bg-danger">{t("platform.channels.links-page.ttl-expired")}</span>;
                } else {
                    const formattedDate = expireDate.toLocaleDateString('es-ES');
                    return (
                        <div className="text-center">
                            <small className="text-muted d-block">{t("platform.channels.links-page.ttl-expires-on")}</small>
                            <span className="badge text-white-dark bg-soft-info-alternative">
                                {formattedDate}
                            </span>
                        </div>
                    );
                }
            }
        },
        {
            name: t("platform.channels.links-page.resume-clicks-conversion"),
            sortable: false,
            center: true,
            cell: (row) => (
                <>
                    {
                        (row.clicks || row.conversion) ?
                            <PieChart
                                datasetName={t("platform.channels.links-page.summary")}
                                width={270}
                                dataset={{
                                    labels: [t("platform.channels.links-page.clicks-label"), t("platform.channels.links-page.conversions-label")],
                                    data: [row.clicks, row.conversion],
                                    backgroundColor: ["#CDD7D8", "#0A595F"]
                                }}
                            />
                            :
                            <div className="py-5">
                                <span className="badge bg-soft-danger text-danger">{t("platform.channels.links-page.badge-alert")}</span>
                            </div>
                    }
                </>
            )
        },
        {
            name: t("platform.channels.links-page.channel"),
            sortable: true,
            selector: row => row.app === 'wa-business' ? <div><span className="badge text-white-dark bg-soft-info-alternative p-2"><i className="bi bi-whatsapp text-primary fs-5 me-1"></i> {t("platform.channels.links-page.wa-business")}</span></div> : <div><span className="badge bg-primary"><i className="bi bi-whatsapp"></i> {t("platform.channels.links-page.wa-standard")}</span></div>,
        },
        {
            name: t("platform.channels.links-page.total-clic"),
            sortable: true,
            center:true,
            with: 10,
            selector: row => row.clicks,
        },
        {
            name: t("platform.channels.links-page.creation-date"),
            sortable: true,
            with: 15,
            selector: row => DateUtil.format(row.date),
        },
        {
            name: t("platform.channels.links-page.actions"),
            sortable: false,
            center: true,
            exportable: false,
            cell: (row) => {

                return (
                    <div className="btn-group" role="group">
                        <button className="btn  bg-soft-info-alternative text-white-dark btn-sm" onClick={() => copyToClipboard(row.link)}>
                            <i className="bi bi-clipboard"></i> {t("platform.channels.links-page.btn-copy")}
                        </button>

                        <div className="btn-group">
                            <button type="button" className="btn bg-soft-info-alternative text-white-dark btn-icon btn-sm dropdown-toggle dropdown-toggle-empty" data-bs-toggle="dropdown" aria-expanded="false"></button>

                            <div className="dropdown-menu dropdown-menu-end mt-1" >
                                {/* <button
                                    className="dropdown-item"
                                    onClick={() => setshowModalEmbed({ show: true, link: row})}>
                                     {t("platform.channels.links-page.btn-insert")}
                                  </button> */}
                                <button className="dropdown-item" onClick={() => downloadQR(row.token)}>
                                    <i className="bi bi-download"></i> {t("platform.channels.links-page.btn-download")}
                                </button>
                                <button className="dropdown-item" onClick={() => setShowModalEdit({ show: true, link: row })} >
                                    <i className="bi bi-pencil"></i> {t("platform.channels.links-page.btn-edit")}
                                </button>
                                {
                                    (row.advanced_follow) ?
                                        <>
                                            <button className="dropdown-item" onClick={() => downloadReportsClicks(row)}>
                                                <i className="bi bi-cursor"></i> {t("platform.channels.links-page.reports-clicks")}
                                            </button>
                                            <button className="dropdown-item" onClick={() => downloadReportsConversions(row)}>
                                                <i className="bi bi-envelope-check"></i> {t("platform.channels.links-page.reports-conversions")}
                                            </button>
                                        </>
                                        : null
                                }
                                <button className="dropdown-item" onClick={() => deleteLink(row)}>
                                    <i className="bi bi-trash"></i> {t("platform.channels.links-page.btn-delete")}
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }
        },
    ], []);

    const downloadQR = (token) => {
        const width = 600;
        const height = 600;

        const svg: any = document.getElementById(`qr-img-${token}`);
        const serializer = new XMLSerializer();
        const svgString = serializer.serializeToString(svg);
        const image = new Image();
        function downloadImage() {
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, width, height);
            const link = document.createElement('a');
            link.download = `${token}.png`;
            link.href = canvas.toDataURL('image/png');
            link.click();
        }
        image.src = 'data:image/svg+xml;base64,' + btoa(svgString);
        image.onload = downloadImage;

        AlertService.toastSuccess(`${t('platform.channels.links-page.download-image')}`, 2000)
    }

    const downloadReportsClicks = async (row) => {
        const promise = async () => {
            const response = await ShortLinksService.getReportClicks(account.id, row.token);

            const blob = new Blob([response], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.setAttribute("download", t("platform.channels.links-page.reports-clicks-filename"));
            link.style.display = "none";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(url);
        }
        AlertService.toastLoading(promise(), t("platform.channels.links-page.alert-1"), t("platform.channels.links-page.alert-2"), t("platform.channels.links-page.alert-3"));
    }

    const downloadReportsConversions = async (row) => {
        const promise = async () => {
            const response = await ShortLinksService.getReportsConversions(account.id,row.token );

            const blob = new Blob([response], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.setAttribute("download", t("platform.channels.links-page.reports-conversions-filename"));
            link.style.display = "none";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(url);
        }
        AlertService.toastLoading(promise(), t("platform.channels.links-page.alert-1"), t("platform.channels.links-page.alert-2"), t("platform.channels.links-page.alert-3"));
    }

    const copyToClipboard = (link) => {
        // Crear un elemento de texto temporal
        const elementoTemporal = document.createElement("textarea");
        elementoTemporal.value = link;

        // Agregar el elemento temporal al DOM
        document.body.appendChild(elementoTemporal);

        // Seleccionar el texto temporal
        elementoTemporal.select();

        // Copiar el texto seleccionado en el portapapeles
        document.execCommand("copy");

        // Remover el elemento temporal del DOM
        document.body.removeChild(elementoTemporal);

        AlertService.toastSuccess(`${t('platform.channels.links-page.copied-element')}`, 2000)
    }

    const deleteLink = async (link) => {
        const isConfirmed = await AlertService.warning(`${t('platform.channels.links-page.warning-title')}`, `${t('platform.channels.links-page.warning-text')}`, async () => {
            try {
                await ShortLinksService.delete(account.id, link.token)
                await getShortLinks();
            } catch (error) {
                console.error(error);
                AlertService.error(`${t('platform.channels.links-page.error-title')}`, `${t('platform.channels.links-page.error-text')}`)
            }
        });

        if (isConfirmed) {
            AlertService.toastSuccess(`${t('platform.channels.links-page.successfully')}`)
        }
    }

    const handleCloseLinkModal = async (refresh) => {
        if (refresh) {
            await getShortLinks();
        }
        setShowModalAdd(false)
    }

    const handleEditLink = async (refresh) => {
        if (refresh) {
            await getShortLinks();
        }

        setShowModalEdit({ show: false, link: null })
    }

    const getShortLinks = async () => {
        const { data } = await call(() => ShortLinksService.getLinks(account.id));
        const filter = channel.toUpperCase() === APPS.WHATSAPP_STANDAR ? 'waweb' : 'wa-business';

        setLinks(data.filter(d => d.app === filter))
    }

    useEffect(() => {
        getShortLinks()
    }, [])


    return (
        <>
            <Header />
            <Aside />

            <main id="content" role="main" className="main">
                <div className="content container-fluid">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm mb-2 mb-sm-0">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb breadcrumb-no-gutter">
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >{t('platform.platform-title')}</span></li>
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >{t('platform.channels.channels-title')}</span></li>
                                        <li className="breadcrumb-item active" aria-current="page">{channel.toUpperCase() === APPS.WHATSAPP_STANDAR ? t('platform.channels.links-page.breadcrumb-wa-standard'): t('platform.channels.links-page.breadcrumb-wa-business')}</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>

                        <div className="row align-items-center mt-3">
                            <div className="col-sm mb-2 mb-sm-0 d-flex align-items-center">

                                <button type="button" className="btn bg-soft-info-alternative text-white-dark btn-icon me-3" onClick={() => navigate(-1)}>
                                    <i className="bi-chevron-left"></i>
                                </button>

                                <h2 className="page-header-title m-0 me-3 text-dark">{t('platform.channels.links-page.link-messages')}</h2>
                            </div>

                            <div className="col-sm-auto">
                                <Button className="btn btn-primary btn-sm" onClick={() => setShowModalAdd(true)}><i className="bi-plus-lg"></i>  {t("platform.channels.links-page.create-link")} </Button>
                            </div>
                        </div>

                    </div>


                    <CustomDataTable
                        columns={columns}
                        data={links}
                        hideAccountsFilter
                        isLoading={isRequesting}
                        filter={(row, term) => {
                            if (!term) return true;

                            return (
                                `${row.name}`.match(new RegExp(`${term}`, 'i'))
                            )
                        }}
                    />

                </div>
                <Footer />
            </main>

            <CreateLinkModal
                showModalLink={showModalAdd}
                onRequestClose={handleCloseLinkModal}
            />

            <EmbedCodeModal
                state={showModalEmbed}
                onRequestClose={() => setshowModalEmbed({ show: false, link: null })}
            />

            <EditLinkModal
                state={showModalEdit}
                onRequestClose={(refresh) => handleEditLink(refresh)}
            />

        </>
    )
}

export default MessageLinksPage
